// extracted by mini-css-extract-plugin
export default {"codeInput":"code-input_codeInput__kykse","box":"code-input_box__fMbNw","hl":"code-input_hl__rbW2L","star":"code-input_star__pVtkL"};